export default __webpack_public_path__ + "static/media/GR00021-star.ddf99ea1.svg";